// extracted by mini-css-extract-plugin
export var active = "_hy-2";
export var recordingDot = "_hy-1";
export var recordingIndicator = "_hy-0";